A question from SEEK's library.

This consists of label text displayed to a user and an input for them to select a response.
